module.exports = __webpack_public_path__ + "static/media/VPM_desktop_2.8d6508f5.jpg";